export default [  
  {
    id: '1',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33534.png',
    symbol: 'BTC70000',
    name: 'BTC 70000',
    decimals: '9',
    address: '9MrLcZzCXXsH8UX1J6jDJac1ENkCZYuiqzFSishrCqwc', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...27',
    exchange_rate: '0.00000000000027', 
    initial_price: "0.00000000000008993",
    coinmarketcap: "https://coinmarketcap.com/currencies/btc-70000/", 
  }, 
  {
    id: '2',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33396.png',
    symbol: 'ROBOTAXI',
    name: 'ROBOTAXI',
    decimals: '9',
    address: 'FstfNjRFcvknXFRcEzSjnC5BrDBcncic4BbE8ofbruCt', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...32',
    exchange_rate: '0.00000000000032', 
    initial_price: "0.0000000000001055",
    coinmarketcap: "https://coinmarketcap.com/currencies/robotaxi-solana/", 
  }, 
  {
    id: '3',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33531.png',
    symbol: 'GOATAI',
    name: 'GOAT AI',
    decimals: '9',
    address: '7kjCdPqW8cWHHv5oB5qwYiVeiZhBhmZthdW7AWkhsoiy', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...29',
    exchange_rate: '0.00000000000029', 
    initial_price: "0.00000000000009002",
    coinmarketcap: "https://coinmarketcap.com/currencies/goat-ai/", 
  }, 
  {
    id: '4',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33739.png',
    symbol: 'HALLOWEEN',
    name: 'HALLOWEEN',
    decimals: '9',
    address: '3efikJa5F2MyUoGAiKX9KcAeg7C1kribfZ6Swy4uiKXh', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...33',
    exchange_rate: '0.00000000000033', 
    initial_price: "0.0000000000001065",
    coinmarketcap: "https://coinmarketcap.com/currencies/halloween-solana/", 
  }, 
  {
    id: '5',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33560.png',
    symbol: 'ORANGE',
    name: 'Annoying Orange',
    decimals: '9',
    address: '4sx9a8c81cPWYPy3QVptKcgZu87ncixZp5d2cxeVpump', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.00006',
    exchange_rate: '0.00006', 
    initial_price: "0.00001728",
    coinmarketcap: "https://coinmarketcap.com/currencies/annoying-orange-sol/", 
  }, 
  {
    id: '6',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33693.png',
    symbol: 'HOOT',
    name: 'HOOT',
    decimals: '9',
    address: 'HootvhN1jGXQk8APL2fD1StHqu9eWZJbMmfdutf9hnLV', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.000017',
    exchange_rate: '0.000017', 
    initial_price: "0.0000152",
    coinmarketcap: "https://coinmarketcap.com/currencies/hoot/", 
  }, 
  {
    id: '7',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33701.png',
    symbol: '47TRUMP',
    name: '47TH POTUS TRUMP',
    decimals: '9',
    address: '7aBf3zq7ZdACihGZ1kwciJ8agd6GFcsc9JHhHyq8sS6', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...48',
    exchange_rate: '0.00000000000048', 
    initial_price: "0.0000000000001522",
    coinmarketcap: "https://coinmarketcap.com/currencies/47th-potus-trump/", 
  }, 
  {
    id: '8',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33458.png',
    symbol: 'WLFI',
    name: 'World Liberty Financial',
    decimals: '9',
    address: 'DqRAkLs2DquKDXSqU6XpTeYJyrZn9FZNwmhXG2GXdrYQ', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...29',
    exchange_rate: '0.00000000000029', 
    initial_price: "0.00000000000009096",
    coinmarketcap: "https://coinmarketcap.com/currencies/world-liberty-financial-space/", 
  }, 
  {
    id: '9',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33737.png',
    symbol: 'MX',
    name: 'MX69420',
    decimals: '9',
    address: '7bpFPJqRpb8Wn8VX9rjNLWEsccCTjKqwmJ7wMX89VAzZ', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0019',
    exchange_rate: '0.0019', 
    initial_price: "0.0005128",
    coinmarketcap: "https://coinmarketcap.com/currencies/mx69420/", 
  }, 
  {
    id: '10',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/30793.png',
    symbol: 'AlphaAI',
    name: 'Alpha AI',
    decimals: '9',
    address: '6HPBookTDQeTvfFiVQ7d2jXUmCt7yFcBgKPWef7uTbFC', 
    vesting_period: '24 Months',
    explorer: 'https://solscan.io/', 
    network: "Solana", 
    display_price: '0.0...17',
    exchange_rate: '0.0000017', 
    initial_price: "0.000000444",
    coinmarketcap: "https://coinmarketcap.com/currencies/alpha-ai/", 
  }, 
];
  